import React, { Fragment, useEffect, useState, useCallback } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

// import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import { DataGridPremium, GridActionsCellItem, GridToolbar } from '@mui/x-data-grid-premium';
import CreditCardsModal from "../../components/editCreditCardsModal"
import editIcon from "../../img/pencil-icon.svg";
import { createErrorMessage } from "../../utils";
import { useLocation, useHistory } from "react-router-dom";
import { Checkbox, TextField } from '@mui/material';
import { useNotification } from '../../context/NotificationContext';
import { useGetCreditCardsPagedQuery } from '../../services/creditCards';
import { useGetAccountsFastListQuery } from '../../services/accountsApi';

import {useLazyGetBrandNamesFromApiQuery, useLazyGetCardTypesFromApiQuery, useEditCreditCardMutation, useCreateCreditCardMutation } from "../../services/creditCards";
import DebounceInput from '../../components/DebounceInput';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

function tableCellName(firstName, lastName, email) {
  return (
    <div className="d-flex align-items-center">
      <div>
        <p className="name-font">{firstName + " " + lastName}</p>
        <p className="email-font">{email}</p>
      </div>
    </div>
  )
}

function getExpirationDate(params) {
  return `${params.row.expirMonth || ''}/${params.row.expirYear || ''}`;
}

function getErrorMessages(res) {

  let errors = res.response?.validation?.response || [];

  let errors_array = Object.entries(errors);
  var errorsMessages = errors_array.reduce((errorsMessages, [key, error]) => {
    if (error && !error.valid && error.message) errorsMessages.push(error.message);
    return errorsMessages;
  }, [])

  if (!errorsMessages || errorsMessages.length == 0) {
    errorsMessages.push(["Error in form"]);
  }
  // some errors dont come in the res.response.validation.response, and there are to generic

  return errorsMessages;
}

function getDefaultsValues(searchParams) {
  const value = searchParams.get("showInactiveCards");
  const showInactiveCards = value === "false" ? false : Boolean(value); //A: this is becasue Boolean("false") is true

  return {
    pageNumber: Number(searchParams.get("pageNumber")) || 1,
    pageSize: Number(searchParams.get("pageSize")) || 100,
    showInactiveCards: showInactiveCards,
    searchText: searchParams.get("searchText") || "",
  }
}

export default function CreditCards() {

  const { showNotification } = useNotification();

  const [initGetBrandNamesFromApi, {isLoading: getBrandNamesFromApiIsLoading}] = useLazyGetBrandNamesFromApiQuery();
  const [initGetCardTypesFromApi, {isLoading: getCardTypesFromApiIsLoading}] = useLazyGetCardTypesFromApiQuery();
  const [initEditCreditCard, {isLoading: editCreditCardIsLoading}] = useEditCreditCardMutation();
  const [initCreateCreditCard, {isLoading: createCreditCardIsLoading}] = useCreateCreditCardMutation();

  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);

  const { pageNumber: numberDftl, pageSize: sizeDftl, showInactiveCards: showDflt, searchText: searchDflt } = getDefaultsValues(searchParams);


  const [pageNumber, setPageNumber] = useState(numberDftl);
  const [pageSize, setPageSize] = useState(sizeDftl);
  const [showInactiveCards, setShowInactiveCards] = useState(showDflt);
  const [searchText, setSearchText] = useState(searchDflt);
  const { data: creditCards, refetch: refetchCCPaged, error: ccError, isError: ccIsError, isLoading: ccIsloading, isFetching: ccIsFetching } = useGetCreditCardsPagedQuery({
    pageNumber,
    pageSize,
    isDeleted: false, //A: we dont want to show deleted cards
    active: showInactiveCards ? false : true,
    search: searchText,
  });

  //useGetAccountsFastListQuery
  const { data: users, refetch: refetchUsers, error: usersError, isError: usersIsError, isLoading: usersIsLoading, isFetching: usersIsFetching } = useGetAccountsFastListQuery();

  const [onSubmitErrors, setOnSubmitErrors] = useState([]);

  let [cardTypes, setCardTypes] = useState([]);
  let [cardBrands, setCardBrands] = useState([]);

  const [creditCardOnEditing, setCreditCardOnEditing] = useState(null);

  const [snackBarOpen, setSnackBarOpen] = useState(false);

  const [columns, setColumns] = useState([
    { field: 'id', hide: true },
    { field: 'nameOnCard', headerName: 'NAME ON CARD', flex: 1, },
    { field: 'cardBrandName', headerName: "CARDS'S BRAND NAME", flex: 1, },
    { field: 'cardTypeName', headerName: "CARDS TYPE NAME", flex: 1, },
    { field: 'last4Digits', headerName: "LAST 4 DIGITS", flex: 1 },
    { field: 'expirationDate', headerName: "EXPIRATION DATE", valueGetter: getExpirationDate, flex: 1, },
    {
      field: 'assignedUserName', headerName: "ASSIGNED USER", flex: 1,
    },
    {
      headerName: '', field: 'edit', flex: 0,
      renderCell: (params) => {
        return <button style={{ cursor: 'pointer' }} className="edit-button" onClick={() => onRowClick(params.row)} id="AdminTools-Creditcads-datagrid-edit-button">
          <img src={editIcon} alt='edit icon' height="18px" width="18px" />Edit</button>
      }
    },
  ]);

  function snackBarHandleClose() {
    setSnackBarOpen(false)
  }

  function onRowClick(creditCardOnEditing) {
    let aux = { ...creditCardOnEditing };
    delete aux.cardNumber;
    delete aux.cvvCode;
    delete aux.additionalCode;
    //A: cardNumber, cvvCode and additionalCode are encrypted
    setCreditCardOnEditing(aux);
  }

  /**
   * If the credit card in the array is the one that needs to be updated, then update it, otherwise,
   * return the credit card as is.
   * @param ccEdited - the credit card that was edited
   */
  function updateCreditCards(ccEdited) {
    //A: here we refetch our list of datagrid and parent card dropdown, because the edit petition are made with fetch not with redux rtk query so we need to refetch
    refetchCCPaged();
  }

  //update the url with the query params in the state
  useEffect(() => {
    searchParams.set("tab_index", 2); //A: this is the index of the tab in the admin tools
    searchParams.set("pageNumber", pageNumber);
    searchParams.set("pageSize", pageSize);
    searchParams.set("showInactiveCards", showInactiveCards);
    searchParams.set("searchText", searchText);

    history.push(`/dashboard/admintools?${searchParams.toString()}`);
  }, [pageNumber, pageSize, showInactiveCards, searchText, history]);

  useEffect(() => {
    let isMounted = true;

    async function initGetLookUpTables() {
      try {
        let promises = [];
        promises.push(initGetCardTypesFromApi().unwrap());
        promises.push(initGetBrandNamesFromApi().unwrap());

        const values = await Promise.all(promises);

        if (isMounted) {
          setCardTypes(values[0].data);
          setCardBrands(values[1].data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    initGetLookUpTables();

    return () => {
      isMounted = false;
    };
  }, []);

  // console.log("users parent : " , users)
  // console.log("users IsLoading parent: " , usersIsLoading)

  async function editCreditCardOnSubmit(newCreditCard, wasEditing) {
    setOnSubmitErrors([]);
    try {
      let res;
      wasEditing ? res = await initEditCreditCard(newCreditCard) : res = await initCreateCreditCard(newCreditCard);
      console.log(res)
      if (res.success == false) {
        setOnSubmitErrors(getErrorMessages(res));
        return;
      }

      updateCreditCards(res.response.creditCard);
      //A: edit or creation successfully
      setCreditCardOnEditing(false);
      setSnackBarOpen(true);
    } catch (error) {
      console.log(error)
      console.log("error: " + JSON.stringify(error))
    }
  }

  function localOnPaginationModelChange(params) {
    let { pageSize: gridPageSize, page: gridPage } = params;
    if (gridPageSize != pageSize) setPageSize(gridPageSize);
    let gridPageNumberFixed = gridPage + 1;
    if (gridPageNumberFixed != pageNumber) setPageNumber(gridPageNumberFixed);
  }

  useEffect(() => {
    if (ccIsError) {
      showNotification(createErrorMessage(ccError), 'error');
    }
  }, [ccIsError])

  return (
    <Fragment>
      <div className='tab-title-container' >
        <h3 style={{ margin: "0 1em 0 0" }}>Credit Cards</h3>

        {/* {isLoading && <CircularProgress size='24px' style={{ color: "#F29B1B" }} />} */}

      </div>

      {/* {error && <p>Error getting Credit Cards</p>} */}

      {creditCardOnEditing && <Fragment>
        <Modal
          open={creditCardOnEditing ? true : false}
          onClose={() => setCreditCardOnEditing(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <CreditCardsModal creditCard={creditCardOnEditing} setEditing={setCreditCardOnEditing} onSubmit={editCreditCardOnSubmit}
              onSubmitErrors={onSubmitErrors}
              setOnSubmitErrors={setOnSubmitErrors}
              cardTypes={cardTypes}
              cardBrands={cardBrands}
              users={users}
              usersIsLoading={usersIsLoading || usersIsFetching}
              setCreditCards={() => { console.log("hello from setCreditCards") }}
              updateCreditCards={updateCreditCards}
            />
          </Box>
        </Modal>
      </Fragment>
      }

      <Snackbar open={snackBarOpen} autoHideDuration={6000} onClose={snackBarHandleClose}>
        <Alert onClose={snackBarHandleClose} severity="success" sx={{ width: '100%' }}>
          Done!
        </Alert>
      </Snackbar>

      <div style={{ height: '70vh', width: '100%' }}>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '0.75em' }}>
          <div style={{ display: 'flex', width: '50%' }} >
            <div style={{ width: '50%' }}>
              <DebounceInput
                sx={{ width: '100%' }}
                defaultValue={searchText}
                placeholder="Search..."
                debounceTimeout={500}
                handleDebounce={(value) => setSearchText(value)}
                id="AdminTools-Creditcads-search-box"
              />
            </div>
            <div>
              <Checkbox checked={showInactiveCards} id="AdminTools-Creditcads-showInactiveCreditCards-Checkbox" name="Show Inactive Cards" onClick={() => setShowInactiveCards(prev => !prev)} />
              <label htmlFor="AdminTools-Creditcads-showInactiveCreditCards-Checkbox" style={{ fontSize: '14px', color: 'var(--orange)' }}>Show Inactive Cards</label>
            </div>
          </div>
          <Button variant='outlined' onClick={() => setCreditCardOnEditing(true)} >New Credit Card</Button>
        </div>

        <DataGridPremium
          pagination
          paginationMode="server"
          sx={{ borderRadius: "1em", backgroundColor: 'white', padding: '1em' }}
          rows={creditCards?.items || []} columns={columns}
          disableSelectionOnClick
          loading={ccIsloading || ccIsFetching}
          initialState={{
            pagination: { paginationModel: { pageSize: sizeDftl, page: numberDftl - 1 } }, //A: the pagination starts in 0, but the api starts in 1
          }}
          onPaginationModelChange={localOnPaginationModelChange}
          rowCount={creditCards?.totalCount}
          page={pageNumber - 1} //A: the pagination starts in 0, but the api starts in 1
          pageSize={pageSize}
        />
      </div>

    </Fragment>
  )
}